/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Lessing_Gymnasium3Inputs */

const en__field__enum_schoolname_lessing_gymnasium3 = /** @type {(inputs: _Field__Enum_Schoolname_Lessing_Gymnasium3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankfurt`)
};

const de__field__enum_schoolname_lessing_gymnasium3 = /** @type {(inputs: _Field__Enum_Schoolname_Lessing_Gymnasium3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessing-Gymnasium`)
};

/**
* | output |
* | --- |
* | "Frankfurt" |
*
* @param {_Field__Enum_Schoolname_Lessing_Gymnasium3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_lessing_gymnasium3 = /** @type {((inputs?: _Field__Enum_Schoolname_Lessing_Gymnasium3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Lessing_Gymnasium3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_lessing_gymnasium3(inputs)
	return de__field__enum_schoolname_lessing_gymnasium3(inputs)
});
export { _field__enum_schoolname_lessing_gymnasium3 as "_field__enum_schoolName_Lessing_Gymnasium" }